import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { guaranteeBadges } from '../data/content';
export function GuaranteeSection() {
  return <section className="border-b border-line bg-panel py-20 sm:py-24" data-id="element-124" data-mp="4vjmq3szb4em">
      <div className="mx-auto max-w-4xl px-5 text-center sm:px-8" data-id="element-125" data-mp="9tbhr6ox76n1">
        <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-acid" data-id="element-126" data-mp="et620re6wxz4">
          Zero risk · 100% protected
        </p>
        <ShieldCheckIcon className="mx-auto mt-6 h-16 w-16 text-acid" aria-hidden="true" data-id="element-127" data-mp="jrr7b58au7uf" />
        <h2 className="mt-6 font-display text-4xl font-bold uppercase leading-none tracking-tight text-white sm:text-5xl" data-id="element-128" data-mp="nsb58b0p5fhm">
          7-day money-back guarantee
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-white/60" data-id="element-129" data-mp="xim6tqwwrclc">
          Open everything. Print the sessions. Run them on your pitch. If the
          Total Academy System doesn&rsquo;t make your academy dramatically more
          organized and professional, we refund every penny — no questions
          asked.
        </p>

        <ul className="mx-auto mt-10 grid max-w-2xl gap-px overflow-hidden border border-line bg-line sm:grid-cols-3" data-id="element-130" data-mp="20su2gye3efow">
          {guaranteeBadges.map(badge => <li key={badge} className="bg-panel px-4 py-5 font-display text-lg font-bold uppercase tracking-tight text-white" data-id="element-131" data-mp="1vu9atncwp4c2">
              {badge}
            </li>)}
        </ul>

        <p className="mt-6 text-xs font-semibold uppercase tracking-[0.16em] text-white/40" data-id="element-132" data-mp="2jjbsgv7jix6k">
          Satisfaction guaranteed, or your money back.
        </p>
      </div>
    </section>;
}